export enum specialCase {
  PUBLISHER = 'publisher',
  GROUP = 'group',
  GIVEN = 'given',
  FAMILY = 'family',
  SUFFIX = 'suffix',
}
